import { useCallback } from 'react'
import { useStore } from 'react-redux'
import moment from 'moment'

import { clearFlightSearchCacheEntry } from 'actions/FlightActions'
import { FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES, PREFETCH_FLIGHT_SEARCH_MIN_REMAINING_TIME_IN_MINUTES } from 'constants/flight'
import { useAppDispatch } from 'hooks/reduxHooks'

export default function useInvalidateStalePrefetchedFlightSearches(flightSearchKeys: Array<string>) {
  const dispatch = useAppDispatch()
  const store = useStore()

  return useCallback(() => {
    const minimumRemainingTime = PREFETCH_FLIGHT_SEARCH_MIN_REMAINING_TIME_IN_MINUTES * 60 * 1000
    const { flights } = store.getState() as App.State

    flightSearchKeys.forEach(key => {
      const timestamp = flights.searchV2Flights[key]?.timestamp
      if (!timestamp) return

      const expiryTimestamp = moment(timestamp).add(FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES, 'minutes').toDate().getTime()
      const remainingTime = expiryTimestamp - Date.now()

      if (remainingTime < minimumRemainingTime) {
        dispatch(clearFlightSearchCacheEntry(key))
      }
    })
  }, [dispatch, flightSearchKeys, store])
}
